"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.configProviderActions = exports.initialState = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const slices_1 = require("../../utils/@reduxjs/slices");
const types_1 = require("./types");
const REDUCER_KEY = 'configProvider';
// The initial state of the configProvider container
exports.initialState = (0, slices_1.getPreloadedState)(REDUCER_KEY, {
    config: {
        API_URL: '',
        MOBILE_WEB_APP_URL: '',
        DESKTOP_WEB_APP_URL: '',
        AUTH_REDIRECT_URL: '',
        CDN_URL: '',
        AUTH_SERVER_URL: '',
        BETGAMES_PARTNER_CODE: '',
        BETGAMES_SERVER: '',
        BETGAMES_CLIENT_URL: '',
        TURBOGAMES_LAUNCH: '',
        TURBOGAMES_LAUNCH_DEMO: '',
        TURBOGAMES_OPERATOR: '',
        SPORTGAMES_PROVIDER_BASE_URL: '',
        CURACAO_LICENCE_URL: '',
        BETRADAR_STATISTICS_URL: '',
        BETRADAR_WIDGETS_URL: '',
        LIVECHAT_LICENCE: '',
        LIVEGAMES_CLIENT_URL: '',
        LIVEGAMES_PARTNER_CODE: '',
        CAPTCHA_KEY: '',
        CLIENT_TYPE: types_1.EClientTypes.DEFAULT,
        LOGO_URL: '',
        LOGO_ICON_URL: '',
        RULES_CDN_FOLDER: '',
        CLIENT_RULES_URL: '',
        TWAIN_GAMES_CLIENT_URL: '',
        TWAIN_GAMES_API_URL: '',
        TWAIN_GAMES_WS_URL: '',
        TWAIN_GAMES_PARTNER_CODE: '',
        CASINO_CLIENT_URL: '',
        CASINO_CUSTOMER_ID: '',
        isDevelopment: false,
        YANDEX_METRIC_ID: 0,
        ODDIN_CLIENT_URL: '',
        ODDIN_BRAND_TOKEN: '',
        HOTJAR_ID: 0,
        FEATURE_FLAGS: {},
        VSPORT_CLIENT_URL: '',
        VSPORT_CLIENT_ID: '',
        VSPORT_LOGOUT_ID: '',
        FRIGG_CLIENT_URL: '',
        BASKET_BALANCE_UPDATE_DELAY: 0,
        BASKET_SUCCESS_SWITCH_DELAY: 2000,
        SENTRY_DSN: '',
        LANDING_APP_RU: '',
        LANDING_APP_EN: '',
        ANDROID_APP_LINK: '',
        YANDEX_CAPTCHA_KEY: '',
        GOOGLE_CAPTCHA_KEY: '',
        HUAWEI_CAPTCHA_KEY: '',
        DATE_OF_SB_COMPETITORS_RENAME: '',
        CAPTCHA_PROVIDER: betweb_openapi_axios_1.CaptchaProviderType.Google,
        LINKED_EVENTS_POLLING_INTERVAL: 10000,
    },
    configLoaded: false,
});
const configProviderSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        setConfig(state, action) {
            state.config = action.payload.config;
            state.configLoaded = true;
        },
    },
});
exports.configProviderActions = configProviderSlice.actions, exports.reducer = configProviderSlice.reducer, exports.sliceKey = configProviderSlice.name;
//# sourceMappingURL=slice.js.map